import { combineReducers } from 'redux';
import schemas from './schemas';
import population from './population';
import qnq from '../../../app/qnq/redux';
import businessComponent from '../../../app/business_component/redux';
import grouping from '../../../app/grouping/redux';
import surveys from '../../../app/survey/redux/surveys';
import updateSurveys from '../../../app/survey/redux/UpdateSurveys';
import configureSurveys from '../../../app/survey/components/redux/surveyConfiguration';
import studySummary from '../../../app/study_summary/redux';
import notifications from '../../../app/notification/redux/index';
import exportData from '../../../common/redux/export';
import qres from '../../../app/qre/redux/index';
import checkSurveys from '../../../app/survey/redux/createSurveyChecker';
import getSurveyDetails from '../../../app/rise/survey/redux/getSurveyDetails';
import reporting from '../../../app/analytics/components/report_table/redux/reporting';
import getReportRefreshStatus from '../../../app/analytics/components/report_table/redux/GetReportRefreshStatus';
import configureRefreshState from '../../../common/redux/configureRefreshState';
import triggerImportData from '../../../app/import_data/redux/TriggerImport';
import getImportMetadata from '../../../app/import_data/redux/GetImportMetadata';
import getAllImportMetadata from '../../../app/import_data/redux/GetAllImportMetadata';
import surveyGroupStatus from '../../../app/survey/redux/surveyGroupStatus';
import complianceSeasons from '../../../app/compliance_season/redux/listComplianceSeasons';
import exportBulkReport from '../../../common/redux/exportBulkReport';

export default combineReducers({
  schemas,
  population,
  qnq,
  businessComponent,
  grouping,
  surveys,
  checkSurveys,
  getSurveyDetails,
  updateSurveys,
  configureSurveys,
  studySummary,
  notifications,
  exportData,
  exportBulkReport,
  qres,
  reporting,
  getReportRefreshStatus,
  configureRefreshState,
  triggerImportData,
  getImportMetadata,
  getAllImportMetadata,
  surveyGroupStatus,
  complianceSeasons,
});
